import React, { lazy } from 'react' 
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client'
import './index.css'
//import App from './App'
import { Provider } from 'react-redux'
import store from './store/store'
import setupInterceptors from "./services/setupInterceptors";
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import swDev from './swDev';
import history from './helpers/history';

const root = createRoot(document.getElementById('root'))
const App = lazy(()=>import('./App'))


root.render(
  <React.Fragment>
    <Provider store={store}>
      <HistoryRouter history={history}future={{ v7_startTransition: true, v7_relativeSplatPath: true}}>
        <App />
      </HistoryRouter>
    </Provider>
  </React.Fragment>

)
//serviceWorkerRegistration.register();

setupInterceptors(store);
swDev();